import React from 'react';
import { Col, Row } from 'antd';

import styles from './index.module.scss';

export default function Wrapper({ children }: React.PropsWithChildren): JSX.Element {
  return (
    <Row justify="center">
      <Col className={styles.wrapper}>
        <div className={styles.content}>{children}</div>
      </Col>
    </Row>
  );
}
